"use client";

import { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    phoneNumber: "",
    contactType: 1, // fixed value as per API
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://api.katchit.in/api/v1/ContactUs/CreateContactUs",
        {
          method: "POST",
          headers: {
            accept: "text/plain",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        alert("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
          phoneNumber: "",
          contactType: 1,
        });
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="contact-page">
      {/* Main Content */}
      <section className="contact-main-section">
        <div className="container">
          <div className="row g-5">
            {/* Map and Quick Contact */}
            <div className="col-lg-5">
              <div className="map-section">
                <div className="map-header">
                  <h3 className="map-title">Find Us Here</h3>
                  <p className="map-subtitle">
                    Visit our office or find us on the map
                  </p>
                </div>

                {/* Google Map */}
                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.4018321768554!2d77.1917017!3d28.647684599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0367697f8295%3A0x79ea17c6870872a8!2sSollace%20Co-works!5e0!3m2!1sen!2sin!4v1754551220582!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Katchit Office Location"
                  ></iframe>
                </div>

                {/* Quick Contact */}
                <div className="quick-contact">
                  <h4 className="quick-contact-title">Quick Contact</h4>
                  <div className="quick-contact-items">
                    <a
                      href="tel:+919990323317"
                      className="quick-contact-item phone"
                    >
                      <div className="quick-icon">
                        <i className="bi bi-telephone-fill"></i>
                      </div>
                      <div className="quick-details">
                        <span className="quick-label">Call Now</span>
                        <span className="quick-value">+91 9990323317</span>
                      </div>
                    </a>
                    <a
                      href="mailto:info@katchit.in"
                      className="quick-contact-item email"
                    >
                      <div className="quick-icon">
                        <i className="bi bi-envelope-fill"></i>
                      </div>
                      <div className="quick-details">
                        <span className="quick-label">Email Us</span>
                        <span className="quick-value">info@katchit.in</span>
                      </div>
                    </a>
                    <div className="quick-contact-item location">
                      <div className="quick-icon">
                        <i className="bi bi-geo-alt-fill"></i>
                      </div>
                      <div className="quick-details">
                        <span className="quick-label">Visit Us</span>
                        <span className="quick-value">
                          10203./4 floor Padam Singh road
                          <br />
                          Karol Bagh New Delhi -110005
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-7">
              <div className="contact-form-wrapper">
                <div className="form-header">
                  <h2 className="form-title">Send us a Message</h2>
                  <p className="form-subtitle">
                    Fill out the form below and we'll get back to you as soon as
                    possible.
                  </p>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="name" className="form-label">
                          <i className="bi bi-person"></i> Name
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your full name"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label">
                          <i className="bi bi-envelope"></i> Email Address
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your email address"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phoneNumber" className="form-label">
                          <i className="bi bi-telephone"></i> Phone Number
                        </label>
                        <input
                          type="tel"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your phone number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="subject" className="form-label">
                          <i className="bi bi-chat-text"></i> Subject
                        </label>
                        <select
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className="form-control"
                          required
                        >
                          <option value="">Select a subject</option>
                          <option value="General Inquiry">General Inquiry</option>
                          <option value="Customer Support">
                            Customer Support
                          </option>
                          <option value="Partnership">Partnership</option>
                          <option value="Feedback">Feedback</option>
                          <option value="Complaint">Complaint</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">
                      <i className="bi bi-chat-dots"></i> Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control"
                      rows="6"
                      placeholder="Tell us how we can help you..."
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-btn">
                    <span>Send Message</span>
                    <i className="bi bi-send"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
